export default __webpack_public_path__ + "static/media/email_What.d9539632.svg";